module.exports = __webpack_public_path__ + "img/6-COCOTIER-min.23e8ca41.jpg";